import { BaseService, Service } from "/@/cool";
@Service("dealerPriceSetting")
class DealerPriceSetting extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["info"] = prefix + "info";
		this.permission["list"] = prefix + "list";
		this.permission["page"] = prefix + "page";
		this.permission["delete"] = prefix + "delete";
		this.permission["priceVersion"] = prefix + "priceVersion";
		this.permission["priceVersionList"] = prefix + "priceVersionList";
		this.permission["copy"] = prefix + "copy";
	}

	priceVersion(data) {
		return this.request({
			url: "/priceVersionList",
			method: "POST",
			data: data
		});
	}
	copy(data: any) {
		return this.request({
			url: "/copy",
			method: "POST",
			data
		});
	}
}
export default DealerPriceSetting;
